/*
 * @param options.url 要打开的 url，比如 https://docs.qq.com/sheet/xxx 这样，支持自动识别详情页，打开 detail 容器，支持自动补充 https 头
 * @param options.wxUrl 指定小程序页面 url （参数要调用方组织好），比如 /pages/xxx/xxx?a=1&b=2 注意参数是否需要编码
 * @param options.replace 是否在当前页打开。true 代表是在当前页打开
 * @param options.ignoreDomainDetect 忽略域名校验。默认是要通过 scenario 校验域名的
 * @param options.isDownLoad 是下载文件链接
 */
export var OpenType;

(function (OpenType) {
  OpenType[OpenType["WxworkBrowser"] = 1] = "WxworkBrowser";
})(OpenType || (OpenType = {}));

;
;